import React from 'react'
import Navigator from '../../components/common/Navigator'

export default function EDCPage() {
  return (
    <div className="lg:w-11/12 lg:mx-auto mx-4 py-6 font-sans">
      <div className="mb-6">
        <Navigator
          slug="EDC"
          // middle_title="Initiatives"
          title="EDC"
        />
        <h1 className="text-2xl font-bold text-gray-900 mb-1">
          Enterprise Development Centre (EDC) – Angamaly
        </h1>
        <p className="text-gray-900 mb-3">
          The Enterprise Development Centre (EDC), Angamaly, functions as a
          dynamic hub for entrepreneurship promotion, skill development, and
          business support. Established under the Kerala Institute for
          Entrepreneurship Development (KIED), the Centre is dedicated to
          empowering aspiring and existing entrepreneurs by offering a
          comprehensive ecosystem of training, incubation, and industry
          collaborations.
        </p>
        <p className="text-gray-900 mb-3">
          EDC acts as a one-stop facilitation centre where innovation meets
          opportunity, supporting individuals and enterprises to transform their
          ideas into viable businesses and scale up their ventures.
        </p>
        <hr className="border-t-2 border-primaryBlue" />
      </div>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Key Services of EDC
        </h2>
        <div className="space-y-6 text-gray-800 leading-7">
          <div>
            <h3 className="font-semibold text-gray-900">
              1. Business Facilitation
            </h3>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                Guidance and support for starting and managing enterprises.
              </li>
              <li>
                Access to schemes, incentives, and funding opportunities from
                government and financial institutions.
              </li>
              <li>
                Advisory services on business registration, compliance, and
                operations.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">
              2. Incubation Support
            </h3>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                Dedicated incubation facilities for startups and small
                enterprises.
              </li>
              <li>
                Mentorship from experienced industry experts and business
                leaders.
              </li>
              <li>
                Infrastructure support including office space, meeting
                facilities, and digital resources.
              </li>
              <li>
                Assistance in developing business models and scaling strategies.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">
              3. Industry–Academia Collaborations
            </h3>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                Building bridges between educational institutions and
                industries.
              </li>
              <li>
                Collaborative projects for research, skill enhancement, and
                innovation.
              </li>
              <li>
                Training programs to equip youth and entrepreneurs with
                industry-relevant competencies.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">
              4. Technology Transfer & Innovation
            </h3>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                Promotion of new technologies and sustainable solutions for
                business growth.
              </li>
              <li>
                Support for adopting digital platforms, modern tools, and
                innovative practices.
              </li>
              <li>
                Facilitation of collaborations between innovators, researchers,
                and enterprises.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Who Can Benefit
        </h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-800 leading-7">
          <li>
            Aspiring Entrepreneurs seeking guidance to start their ventures.
          </li>
          <li>
            Existing Entrepreneurs aiming to expand, diversify, or modernize
            operations.
          </li>
          <li>
            Startups looking for incubation, mentorship, and networking
            opportunities.
          </li>
          <li>
            Students & Researchers interested in industry projects and
            entrepreneurship pathways.
          </li>
        </ul>
      </section>
    </div>
  )
}
